<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <!-- TABLA DOCUMENTO -->
          <template>
            <v-tabs v-model="active_tab">
              <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
              <v-tab
                v-for="(tab, index) in tabs"
                :key="index"
                @click="selected(tab.id, tab.descripcion)"
                >{{ tab.descripcion }}</v-tab
              >
              <v-tabs-items>
                <!-- TAB ADMINISTRACION DE PESTAÑAS -->
                <v-card flat v-if="tabSelected == 'Administración'">
                  <grid-administracion
                    @load-pestanas-func="loadPestanas"
                  ></grid-administracion>
                </v-card>
                <v-card flat v-else-if="tabSelected != '' && idTabSelected > 0">
                  <grid-pestana-generica
                    :idPestana="idTabSelected"
                    :nombrePestana="tabSelected"
                  ></grid-pestana-generica>
                </v-card>
              </v-tabs-items>
            </v-tabs>
          </template>
          <!-- TABLA DOCUMENTO -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import GridAdministracion from "@/modules/prodReport/views/GridAdministracion.vue";
import GridPestanaGenerica from "@/modules/prodReport/views/GridPestanaGenerica.vue";

export default {
  name: "producto-reporte-tab",

  components: {
    GridAdministracion,
    GridPestanaGenerica,
  },

  props: {},

  data() {
    return {
      tabs: [],
      proveedor: {},
      rowsTable: [20],
      idTabSelected: -1,
      tabSelected: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      usuarioLogged: "",
      gridDocumento: 20,
      index: "",
      active_tab: -1,
      muestraAdministracion: false,
    };
  },

  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.usuarioLogged = this.$store.getters.userLogged;

    this.loadPestanas();

    this.tabSelected = this.$store.getters.subTabSelectedStored;
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );

    if (
      this.usuarioLogged.tipo == "AGENCIA" ||
      this.usuarioLogged.tipo == "ADMINISTRADOR"
    ) {
      this.muestraAdministracion = true;
    }
  },

  methods: {
    async loadPestanas() {
      this.loading = true;
      this.tabs = await this.loadNombrePestanas();
      for (let i = 0; i < this.tabs.length; i++) {
        const pestana = this.tabs[i];
        if (pestana.descripcion === this.tab) {
          this.idTabSelected = pestana.id;
          break;
        }
      }

      if (this.muestraAdministracion) {
        this.tabs.push({
          id: -999,
          contrato: {
            id: this.$store.getters.contratoStored,
          },
          descripcion: "Administración",
        });
      }

      if (this.tabs.length > 0 && this.idTabSelected != -999) {
        let descTab = this.$store.getters.subTabSelectedStored.toUpperCase();
        let indexTab = this.tabs.indexOf(
          this.$store.getters.subTabSelectedStored
        );

        this.tabs.forEach((tab, index) => {
          if (tab.descripcion.toUpperCase() == descTab) {
            indexTab = index;
          }
        });

        if (descTab == "PRODUCTOS") {
          indexTab = 0;
        }

        // console.log("index::" + indexTab);
        // console.log("descTab::" + descTab);
        // console.log("stringify:" + JSON.stringify(this.tabs, null, 2));
        //this.selected(this.tabs[0].id, this.tabs[0].descripcion);
        if (this.tabs && this.tabs[indexTab] && this.tabs[indexTab].id) {
          this.selected(this.tabs[indexTab].id, descTab);
        }
      }
      this.loading = false;
    },
    async loadNombrePestanas() {
      var body = {
        idContrato: this.$store.getters.contratoStored,
      };

      return await axios
        .post("/productoReporte/pestanasToShow", body)
        .then(function (respuesta) {
          return respuesta.data;
        })
        .catch((error) => {
          if (error) {
            console.log("error en loadNombrePestanas:" + error.response);
          } else {
            console.log("error loadNombrePestanas");
          }
          return [];
        });
    },
    reloadDocumento() {
      this.gridDocumento += 22;
      this.gridDocumento2 += 22;
    },
    selected(idTab, tabDescripcion) {
      //console.log("cambia tab::" + idTab + "::" + tabDescripcion + "::");
      this.$store.commit("sub_tab_state", tabDescripcion);
      this.tabSelected = tabDescripcion;
      this.idTabSelected = idTab;

      this.active_tab = this.tabs.indexOf(
        this.$store.getters.subTabSelectedStored
      );

      this.tabs.forEach((tab, index) => {
        if (tab.descripcion == tabDescripcion) {
          this.active_tab = index;
        }
      });

      this.reloadDocumento();
    },
  },
};
</script>
